import type { ComponentChildren } from 'preact';
import { useEffect } from 'preact/hooks';
import { t } from '../lib/i18n.js';
import { closeSheet } from '../lib/ui.js';

export function Sheet(props: {
  title: string;
  children: ComponentChildren;
  footer?: ComponentChildren;
  onClose?: () => void;
}) {
  const close = props.onClose ?? closeSheet;
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      // a picker inside the sheet may have used Escape itself (back to the chosen row)
      if (e.key === 'Escape' && !e.defaultPrevented) close();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [close]);
  return (
    <>
      <div class="sheet-backdrop" onClick={close} />
      <div class="sheet" role="dialog" aria-modal="true" aria-label={props.title}>
        <div class="sheet-head">
          <h3>{props.title}</h3>
          <button type="button" class="btn btn-ghost" onClick={close}>
            {t('close')}
          </button>
        </div>
        <div class="sheet-body">{props.children}</div>
        {props.footer && <div class="sheet-foot">{props.footer}</div>}
      </div>
    </>
  );
}

export function SaveButton(props: {
  label?: string;
  busy: boolean;
  disabled?: boolean;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      class="btn btn-primary btn-block"
      style={{ marginTop: 0 }}
      disabled={props.busy || props.disabled}
      onClick={props.onClick}
    >
      {props.busy ? t('saving') : (props.label ?? t('save'))}
    </button>
  );
}

export function FormErrorLine(props: { error: { message: string } | null }) {
  return props.error ? <div class="form-error">{props.error.message}</div> : null;
}
